<!-- https://8es9hr.axshare.com/#g&p=%E7%90%86%E4%BA%8B%E6%9C%83%E5%AF%A9%E6%9F%A5_1&g=1 -->
<!-- 審查-->

<template>
    <div>
        <div class="col-block">
            <div class="block-header has-border">
                <h3>
                    <strong>儲互社確認</strong>
                </h3>
            </div>
            <div class="block-content">
                <el-form>
                    <el-form-item label="專案編號">{{recordToEdit.code}}</el-form-item>
                    <el-form-item label="理事會會議紀錄">
                        {{meetingRcd[recordToEdit.meetingRcdId]==null?"": meetingRcd[recordToEdit.meetingRcdId].name }}
                        <el-button plain size="small" @click="viewRcd">檢視會議記錄</el-button>
                    </el-form-item>
                    <el-form-item label="借據編號">{{recordToEdit.iouNumber}}</el-form-item>
                    <el-form-item label="結算基準日">{{toMingoDate(recordToEdit.calculateBaseDate)}}</el-form-item>
                    <el-form-item
                        label="社員編號 / 姓名"
                    >{{recordToEdit.member.account}} {{recordToEdit.member.name ||""}}</el-form-item>
                    <el-form-item
                        label="借款起訖日期"
                    >{{toMingoDate(recordToEdit.iou.iouDateStart)}} ~ {{toMingoDate(recordToEdit.iou.iouDateEnd)}}</el-form-item>
                    <el-form-item label="取款金額">{{$addcomma(recordToEdit.iou.amount)}}</el-form-item>
                    <el-form-item
                        label="已還本金金額"
                    >{{$addcomma(recordToEdit.iou.amount-recordToEdit.calculateInfo.loanPriceBeforePay )}}</el-form-item>
                    <el-form-item label="原方案名稱">
                        {{recordToEdit.oldProjectName}}
                        <el-button
                            plain
                            size="small"
                            @click="viewProject(recordToEdit.oldProjectCode)"
                        >檢視方案</el-button>
                    </el-form-item>
                    <el-form-item label="新方案名稱">
                        {{recordToEdit.newProjectName}}
                        <el-button
                            plain
                            size="small"
                            @click="viewProject(recordToEdit.newProjectCode)"
                        >檢視方案</el-button>
                    </el-form-item>
                    <table class="w60">
                        <tr>
                            <td>
                                <label class="el-form-item__label align-left">減免前應還利息</label>
                            </td>
                            <td>{{$addcomma(recordToEdit.calculateInfo.payBackInterest)}}</td>
                            <td>
                                <label class="el-form-item__label align-left">減免前應還違約金</label>
                            </td>
                            <td>{{$addcomma(recordToEdit.calculateInfo.payBackBreakPrice)}}</td>
                        </tr>
                        <tr>
                            <td>
                                <label class="el-form-item__label align-left">利息減免金額</label>
                            </td>
                            <td>{{$addcomma(recordToEdit.interestAmountReduction)}}</td>
                            <td>
                                <label class="el-form-item__label align-left">違約金減免金額</label>
                            </td>
                            <td>{{$addcomma(recordToEdit.annualAmountReduction)}}</td>
                        </tr>
                        <tr>
                            <td>
                                <label class="el-form-item__label align-left">減免後欠繳利息</label>
                            </td>
                            <td>{{$addcomma(recordToEdit.calculateInfo.payBackInterest-recordToEdit.interestAmountReduction)}}</td>
                            <td>
                                <label class="el-form-item__label align-left">減免後欠繳違約金</label>
                            </td>
                            <td>{{$addcomma(recordToEdit.calculateInfo.payBackBreakPrice-recordToEdit.annualAmountReduction)}}</td>
                        </tr>
                    </table>
                </el-form>
            </div>
            <div class="block-footer has-border data-footer">
                <el-button
                    type="primary"
                    v-if="recordToEdit.iouModifyStatus == 8"
                    @click="submitReview(1)"
                >送出啟用</el-button>
                <el-button
                    type="success"
                    v-if="recordToEdit.iouModifyStatus == 8 && isCalculateDateToday"
                    @click="submitReview(1, true)"
                >即刻啟用</el-button>
                <el-button
                    type="danger"
                    v-if="recordToEdit.iouModifyStatus == 8"
                    @click="submitReview(0)"
                >退回結案</el-button>
                <el-button @click="$router.go(-1)">取消</el-button>
            </div>
        </div>
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogEdit"
            append-to-body
            :show-close="false"
            class="modal-show"
        >
            <ListForm
                api
                :id="id"
                v-if="dialogType=='viewRcd'"
                labelPosition="top"
                :recordToEdit="meetingRcd[recordToEdit.meetingRcdId]"
                :formType="meetingRcdFormType"
            >
                <div slot="footer">
                    <el-button type="primary" @click="downLoanMeetingRcd">下載會議記錄</el-button>
                    <el-button @click="dialogEdit=false">關閉</el-button>
                </div>
            </ListForm>
            <el-form v-else>
                <div>
                    <el-form-item label="方案名稱">{{projectSelect.name||""}}</el-form-item>
                    <el-form-item
                        label="是否發放利息攤還"
                    >{{renderEnum(projectSelect.isPayYearStl,'booleanEunm')}}</el-form-item>
                    <el-form-item label="方案類型">{{renderEnum(projectSelect.loanType,'loanType')}}</el-form-item>
                    <el-form-item
                        label="方案適用對象"
                    >{{renderEnum(projectSelect.loanObjects,'loanObjectType',true)}}</el-form-item>
                    <el-form-item
                        label="是否限制股金內放款"
                    >{{renderEnum(projectSelect.restrictInStock,'booleanEunm')}}</el-form-item>
                    <el-form-item
                        label="還款方式"
                    >{{renderEnum(projectSelect.normalPaymentType,'paymentType')}}</el-form-item>
                    <el-form-item label="正常還款年利率">{{projectSelect.normalAnnualRate}}%</el-form-item>
                    <el-form-item
                        label="是否有違約後方案"
                    >{{renderEnum(projectSelect.hasDefault,'booleanEunm')}}</el-form-item>
                    <el-form-item label="違約年利率">{{projectSelect.defaultAnnualRate}}%</el-form-item>
                    <el-form-item label="備註">{{projectSelect.memo}}</el-form-item>
                    <el-form-item label="還款/放款科目">
                        {{projectSelect.projectAccountTitle.capitalAccountTitle.code}}
                        {{projectSelect.projectAccountTitle.capitalAccountTitle.name ||""}}
                    </el-form-item>
                    <el-form-item label="繳息科目">
                        {{projectSelect.projectAccountTitle.interestAccountTitleId.code}}
                        {{projectSelect.projectAccountTitle.interestAccountTitleId.name || ""}}
                    </el-form-item>
                    <el-form-item label="違約金科目">
                        {{projectSelect.projectAccountTitle.ldAccountTitleId.code}}
                        {{projectSelect.projectAccountTitle.ldAccountTitleId.name}}
                    </el-form-item>
                    <el-button @click="dialogEdit=false">關閉</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";

export default {
    name: "loan_plan_change_coop_recheck",
    components: {
        ListForm
    },
    props: {
        // 由父頁 LoanPlanChangeEdit 透過 router-view 帶入，子頁不再自行 getData
        parentRecord: {
            type: Object,
            default: () => ({})
        },
        enumData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            isFirstTime: true,
            active: 0,
            titleLabel: "",
            dialogEdit: false,
            dialogTitle: "",
            allEnum: {},
            dialogType: "chooseIou",
            id: this.$route.params.id == "new" ? 0 : this.$route.params.id,

            recordToEdit: {
                iou: { amount: 0 },
                member: { name: "" },
                calculateInfo: { loanPriceBeforePay: 0 }
            },
            chooseProjectList: {},
            projectSelect: {
                name: "",
                projectAccountTitle: {
                    capitalAccountTitle: { name: "" },
                    interestAccountTitleId: { name: "" },
                    ldAccountTitleId: { name: "" }
                }
            },
            query: {
                action: "getRunningIou"
            },
            workflow: [],
            meetingRcd: {},
            formPathList: {
                理事會同意紀錄: "loan_plan_change_edit",
                設定新方案與減免: "loan_plan_change_project",
                主任審查: "loan_plan_change_review_director",
                經理審查: "loan_plan_change_review_manager",
                理事會審查: "loan_plan_change_review_council",
                督導審查: "loan_plan_change_review_supervision",
                督導組長審查: "loan_plan_change_project_supervision_manager",
                儲互社確認: "loan_plan_change_coop_recheck"
            },
            meetingRcdFormType: [
                {
                    label: "會議日期",
                    key: "meetingDate",
                    type: "date",
                    disabled: true
                },
                {
                    label: "會議記錄名稱",
                    key: "name",
                    type: "input",
                    disabled: true
                },
                {
                    label: "分類",
                    key: "typeKey",
                    type: "select",
                    options: [],
                    disabled: true
                },
                {
                    type: "input",
                    key: "typeOther",
                    disabled: true
                },
                {
                    label: "備註",
                    key: "note",
                    type: "textarea",
                    disabled: true
                }
            ]
        };
    },
    created() {
        this.bindData();
    },
    watch: {
        enumData: {
            handler() {
                this.bindData();
            },
            deep: true
        },
        parentRecord: {
            handler() {
                this.bindData();
            },
            deep: true
        }
    },
    computed: {
        isCalculateDateToday() {
            if (!this.recordToEdit.calculateBaseDate) {
                return false;
            }
            const date = new Date(
                this.recordToEdit.calculateBaseDate.split(" ")[0]
            );
            const today = new Date();
            return (
                date.getFullYear() === today.getFullYear() &&
                date.getMonth() === today.getMonth() &&
                date.getDate() === today.getDate()
            );
        }
    },
    methods: {
        downLoanMeetingRcd() {
            let url =
                API.AssnLoanIouModify +
                `?action=downloadForm&id=${this.recordToEdit.meetingRcdId}`;
            this.mDownloadFile(url);
        },

        renderEnum(objectValue, enumName, isJson = false) {
            if (isJson) {
                objectValue = !objectValue ? [] : JSON.parse(objectValue);
                return objectValue
                    .map(obj => this.allEnum[enumName][obj.toString()])
                    .join("、");
            }
            if (!objectValue) {
                objectValue = 0;
            }

            return !this.allEnum[enumName]
                ? ""
                : this.allEnum[enumName][objectValue.toString()];
        },
        submitReview(result, isImmediate = false) {
            let url = API.coopLoanIouModify + "?action=submitReview";

            let dataPost = new FormData();
            dataPost.append("id", this.id);
            dataPost.append("coopRecheckStatus", result);

            if (isImmediate) {
                dataPost.append("isImmediate", 1);
            }

            const postCB = json => {
                this.showAjaxSuccessMsg();
                // 由父頁 reflashWorkFlow 統一 reload 並自動前往下一流程，子頁不需自行 getData
                this.$emit("reflashWorkFlow", true);
            };
            this.mAxiosPost(url, dataPost, postCB);
        },
        toMingoDate(date) {
            if (date == null) return "";
            let dateArray = date.split(" ")[0].split("-");
            let newYear = parseInt(dateArray[0]) - 1911;

            return `${newYear}-${dateArray[1]}-${dateArray[2]}`;
        },
        viewProject(projectCode) {
            if (!this.recordToEdit.newProjectCode) {
                this.$message.closeAll();
                this.$message({
                    type: "error",
                    message: "尚未選擇方案",
                    duration: 5000
                });
                return;
            }

            this.dialogType = "project";
            this.dialogTitle = "檢視方案";
            this.projectSelect = this.chooseProjectList[projectCode];

            this.dialogEdit = true;
        },
        viewRcd() {
            if (!this.recordToEdit.meetingRcdId) {
                this.$message.closeAll();
                this.$message({
                    type: "error",
                    message: "尚未選擇理事會紀錄",
                    duration: 5000
                });
                return;
            }
            this.dialogType = "viewRcd";
            this.dialogTitle = "檢視理事會紀錄";
            this.dialogEdit = true;
        },

        // 資料由父頁 LoanPlanChangeEdit 透過 props 帶入，不再自行打 API
        bindData() {
            const enu = this.enumData;
            if (!enu || !enu.modifyIou) return;

            this.recordToEdit = Object.assign(
                {},
                this.recordToEdit,
                this.parentRecord
            );
            this.allEnum = enu;
            enu.meetingRcd.forEach(item => {
                this.meetingRcd[item.id] = item;
            });

            enu.modifyProject.forEach(project => {
                this.chooseProjectList[project.code] = project;
            });

            this.meetingRcdFormType[2].options = enu.typeKey;

            this.recordToEdit.calculateInfo = JSON.parse(
                atob(this.recordToEdit.calculateInfo)
            );
            this.recordToEdit.iou = enu.modifyIou;
            this.recordToEdit.member = enu.modifyMember;
        }
    }
};
</script>
<style lang="scss">
.align-left {
    text-align: left;
}
.w60 {
    width: 60%;
}
</style>
